import { BigNumber } from 'ethers'
import { Currency, MarketIndexes } from '../../api/v1/market'
import { Pow18 } from '../../config'
import { CurrencyBalance } from '../../store/account/types'
import { Equal } from '../equal'
import { bn, e2w, isZero } from '../number'
import { getOraclePriceFromIndexes } from '../getOraclePriceFromIndexes'

/**
 * Calculates the total spot conversion margin value based on the provided balances, currencies, and market indexes.
 * @param balances An array of currency balances.
 * @param currencies An array of currencies.
 * @param indexes The market indexes.
 * @returns The total spot conversion margin value as a string.
 */
export function calcTotalSpotConversionMarginValue(
  balances: CurrencyBalance[],
  currencies: Currency[],
  indexes: MarketIndexes,
): BigNumber {
  if (!balances || !currencies || !indexes) return bn(0)
  return balances.reduce((prev, current): BigNumber => {
    const { currency = '', available = '0' } = current
    const { conversionRatio = 0 } =
      currencies.find((v) => Equal.upperCase(v.name, currency)) ?? {}
    const markPrice = getOraclePriceFromIndexes(indexes, currency)
    if (isZero(conversionRatio)) {
      return prev
    }
    const v = bn(available)
      .mul(e2w(conversionRatio))
      .mul(e2w(markPrice))
      .div(Pow18)
      .div(Pow18)
    return prev.add(v)
  }, bn(0))
}
